import {
  GET_COMMUNITY_GROUPS,
  GET_GROUP_LOADING,
  GET_LOADING_OFFSET,
} from '../actions/communityGroups'

const initialState = {
  groups: [],
  loading: false,
  isLoadingOffset: false,
};

const communityGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMUNITY_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case GET_GROUP_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      case GET_LOADING_OFFSET:
        return {
          ...state,
          isLoadingOffset: action.payload,
        };
    default:
      return state;
  }
};

export default communityGroupsReducer;
